/**
 * @typedef {string} tabId
 */

/**
 * SAMA screen tabs
 *
 * @enum {tabId}
 */
export default {
    REQUIREMENTS: 'requirements',
    SERVICE_PROVIDER: 'service-provider',
    COMMISSIONING: 'commissioning',
};
